// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__isoOA","container":"style_container__kwTY8","close":"style_close__3-dkJ"};